/**
 * 地址相关工具函数
 */

/**
 * 地址类型接口
 */
export interface AddressForFormat {
    addressLine1?: string;
    addressLine2?: string;
    city?: string;
    state?: string;
    zipcode?: string;
}

/**
 * 构建完整地址字符串
 * 格式：addressLine1, addressLine2, city, state zipcode
 *
 * @param address 地址对象
 * @returns 格式化后的地址字符串，如果地址为空则返回 undefined
 */
export function buildFullAddress(address?: AddressForFormat): string | undefined {
    if (!address) return undefined;

    const parts: string[] = [];

    // 街道地址 + 建筑/单元号
    if (address.addressLine1) {
        let addressLine = address.addressLine1;
        if (address.addressLine2) {
            addressLine += `, ${address.addressLine2}`;
        }
        parts.push(addressLine);
    }

    // 城市, 州 邮编
    if (address.city && address.state && address.zipcode) {
        parts.push(`${address.city}, ${address.state} ${address.zipcode}`);
    }

    return parts.length > 0 ? parts.join(', ') : undefined;
}
